<div class="ruc-field">
  <label *ngIf="showLabel" for="rucBusca">{{ label }}</label>
  <div class="ruc-input-wrapper">
    <input
      id="rucBusca"
      type="text"
      pInputText
      [value]="rucValue"
      (input)="onRucInput($event)"
      [placeholder]="placeholder"
      style="width: 100%;"
      maxlength="11"
      inputmode="tel"
      [class.ng-invalid]="erro"
      [class.input-encontrado]="encontrado"
      [attr.aria-describedby]="erro ? 'rucErro' : null" />
    <i *ngIf="buscando" class="pi pi-spin pi-spinner ruc-spinner-overlay" aria-hidden="true"></i>
    <i *ngIf="!buscando && encontrado" class="pi pi-check-circle ruc-check-overlay" style="color: #22c55e;" aria-hidden="true"></i>
  </div>
  <small *ngIf="erro" id="rucErro" class="p-error">{{ erro }}</small>
</div>

<!-- Aviso neutro: RUC fora da base publica / consulta indisponivel (nao bloqueia) -->
<div *ngIf="aviso && !encontrado" class="ruc-aviso-banner" role="status" aria-live="polite">
  <i class="pi pi-info-circle" aria-hidden="true"></i>
  <span>{{ aviso }}</span>
</div>

<!-- Banner de registro encontrado -->
<div *ngIf="encontrado" class="ruc-encontrado-banner">
  <i class="pi pi-info-circle"></i>
  <span>{{ 'ruc_busca.infos.registro_encontrado' | translate }}</span>
</div>

<!-- Dialog de busca em andamento (API externa) -->
<p-dialog
  [(visible)]="buscandoExterno"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '420px', height: 'auto' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'ruc_busca.dialogs.buscando_titulo' | translate }}</h2>
        <p>{{ 'ruc_busca.dialogs.buscando_descricao' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body ruc-buscando-body">
    <div class="ruc-buscando-animacao">
      <div class="ruc-buscando-barra"></div>
    </div>
    <p class="ruc-buscando-texto">{{ 'ruc_busca.dialogs.buscando_aguarde' | translate }}</p>
  </div>
</p-dialog>

<!-- Dialog de confirmacao (encapsulado) -->
<app-ruc-confirmacao-dialog
  [(visible)]="mostrarDialogConfirmacao"
  [resultados]="resultados"
  [origem]="origem"
  (confirmar)="onConfirmar($event)"
  (recusar)="onRecusar()">
</app-ruc-confirmacao-dialog>
